import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Home, Search, ArrowLeft } from 'lucide-react';

const fadeUp = {
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0 },
};

const stagger = {
  animate: { transition: { staggerChildren: 0.1 } },
};

export function NotFound() {
  return (
    <motion.div
      initial="initial"
      animate="animate"
      variants={stagger}
      className="min-h-[60vh] flex items-center justify-center px-4"
    >
      <div className="text-center">
        <motion.div variants={fadeUp}>
          <h1 className="text-[10rem] md:text-[14rem] font-bold leading-none">
            <span className="gradient-text">404</span>
          </h1>
        </motion.div>

        <motion.div variants={fadeUp}>
          <p className="text-2xl md:text-3xl font-semibold mb-2">Page Not Found</p>
          <p className="text-surface-500 mb-8 max-w-md mx-auto">
            The page you're looking for doesn't exist or has been moved.
          </p>
        </motion.div>

        <motion.div variants={fadeUp} className="flex items-center justify-center gap-4">
          <button onClick={() => window.history.back()} className="btn-secondary">
            <ArrowLeft size={18} />
            Go Back
          </button>
          <Link to="/" className="btn-primary">
            <Home size={18} />
            Home
          </Link>
          <Link to="/search" className="btn-secondary">
            <Search size={18} />
            Search
          </Link>
        </motion.div>
      </div>
    </motion.div>
  );
}
